
    import { Component, Vue } from 'vue-property-decorator';
    import API from '@/store/userAPI';
    import Multiselect from 'vue-multiselect'
    @Component({
        components: {
            Multiselect
        }
    })
    export default class AddUser extends Vue {   
        buttonText = 'Add'
        drpbiome: any = []
        username: any = []
        email: any = []
        user: any
        private errors = {} as { [id: string]: any };
        private formValues = {
            username: [],
            email: [],
            selectedbiome: []
        } as { [id: string]: any }


        
        private get fieldNames() {
            return Object.keys(this.formValues) as string[];
        }
        private async mounted() {
           
            if (this.$route.params.userId != undefined) {
                try {
                    this.buttonText = 'Edit'
                    this.user = await API.getUser(this.$route.params.userId);
                    
                    this.email = this.user.email;
                    this.username = this.user.username;
                    console.log(this.user);
                } catch (error) {
                    // this.loadingFailed = true;
                    // this.errorMessage = '';
                } finally {
                    // this.loading = false;
                }
            }

            console.log(this.buttonText);
        }

        private async submitForm() {
            console.log(this.username);
            //alert('hi');
            var formPayload = new FormData();
            formPayload.append("Name", this.username);
            formPayload.append("Email", this.email);
            if (this.$route.params.userId != undefined) {
                formPayload.append('UserId', this.$route.params.userId);
            }
            
            

           var responseedit = await API.pushUser(formPayload);
            console.log(responseedit);
            if (responseedit == "Success") {
                alert("Added Successfully");
                this.$router.push({ path: "/Users/" });
            }
            else
                alert(responseedit);
        }


        private get states() {
            return this.fieldNames.reduce(
                (p, c) => {
                    p[c] = this.errors[c] !== undefined ? false : null;
                    return p;
                },
                {} as { [id: string]: boolean | null }
            );
        }


    }
